import { api } from "./client";
import type { ProjectDatabase } from "@mycompbox/shared";

export type { ProjectDatabase };

/** GET /teams/:teamId/database: the connected database's metadata (never the secret), or null. */
export interface ProjectDatabaseView {
  data: ProjectDatabase | null;
  /** Estimated monthly cost of a CompBox-created Cloud SQL database for this project, in US dollars. */
  estimatedMonthlyUsd: number;
}

/**
 * A project's database (ENG-314, ENG-316).
 *
 * The connection string is only ever sent on `save`. It's never returned by
 * the API, and callers must not keep it anywhere (query cache, state) after
 * the request.
 */
export const projectDatabaseApi = {
  get: (teamId: string) => api.get<ProjectDatabaseView>(`/teams/${teamId}/database`),
  /** Add a Cloud SQL database to the stack pull request. The cost must be confirmed. */
  createCloudSql: (teamId: string) =>
    api.post<{ data: ProjectDatabase }>(`/teams/${teamId}/database/cloudsql`, {
      confirmCost: true,
    }),
  /** Paste or replace the connection string. */
  save: (teamId: string, input: { connectionString: string; providerLabel?: string }) =>
    api.put<{ data: ProjectDatabase }>(`/teams/${teamId}/database`, input),
  disconnect: (teamId: string) => api.delete<undefined>(`/teams/${teamId}/database`),
};
